import React from 'react'
import { useCreateQuestion } from '../../Hooks/Features/SurveyManagement/useCreateQuestion'
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Slider } from 'primereact/slider';
import { Calendar } from 'primereact/calendar';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { MuiCss } from '../../utils/Helper';
import _ from 'underscore';

const CreateQuestionBank = ({ showPopUp, setOptions, handleClose, options, apiCall, questionList, fromSurvey }) => {

    const { handleOnChange, formValue, setFormvalue, addOption, removeOption, handleOptionChange, choiceOptions, handleSave, getIcon, showInfo } = useCreateQuestion({ options, setOptions, showPopUp, apiCall, handleClose, questionList, fromSurvey, });

    return (
        <div>
            <Dialog visible={showPopUp?.show}
                header={!_.isEmpty(showPopUp?.data) ? "Edit Question" : "Add Question"}
                onHide={() => formValue?.addQuestion ? apiCall() : handleClose()}
                className="modal-medium"
                style={{ height: "70vh", width: "70%" }}
                draggable={false}
            >
                <div className=' row px-2 mx-0' style={{ height: "550px", overflowY: "auto", overflowX: "hidden", }}>
                    <div className="col-md-6 col-12 my-1" style={{ width: "250px" }} >
                        <label>Section</label><span className="text-danger">*</span>

                        <Autocomplete
                            className="common-autocomplete"
                            value={formValue?.category}
                            onChange={(event, newValue) => {
                                if (!newValue) {
                                    handleOnChange({
                                        target: { name: 'category', value: null }
                                    });
                                    return;
                                }
                                if (typeof newValue === "string" || newValue?.inputValue) {
                                    const categoryName = newValue?.inputValue || newValue;
                                    handleOnChange({
                                        target: {
                                            name: 'category',
                                            value: {
                                                question_category_id: 0,
                                                question_category_name: categoryName,
                                                question_category_key: categoryName.replace(/\s+/g, '_'),
                                                order_number: 1
                                            }
                                        }
                                    });
                                }
                                else {
                                    handleOnChange({
                                        target: {
                                            name: 'category',
                                            value: {
                                                ...newValue,
                                                order_number: 1,
                                            }
                                        }
                                    });
                                }
                            }}
                            filterOptions={(options, params) => {
                                const filtered = options.filter(option =>
                                    option?.question_category_name?.toLowerCase()?.includes(params.inputValue.toLowerCase())
                                );
                                const { inputValue } = params;
                                if (inputValue !== "" && !options.some(opt => inputValue === opt.question_category_name)) {
                                    filtered.push({ inputValue, question_category_name: `${inputValue}` });
                                }
                                return filtered;
                            }}
                            options={options?.category}
                            getOptionLabel={(option) => typeof option === "string" ? option : option.question_category_name || ""}
                            renderOption={(props, option) => (
                                <li {...props} key={option.question_category_id}>
                                    {option.question_category_name}
                                </li>
                            )}
                            freeSolo
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    placeholder="Select a section"
                                    style={{ width: "100%" }}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        const currentName = formValue?.category?.question_category_name;

                                        if (!value) {
                                            handleOnChange({ target: { name: 'category', value: null } });
                                        } else if (value !== currentName) {
                                            handleOnChange({
                                                target: {
                                                    name: 'category',
                                                    value: {
                                                        question_category_id: 0,
                                                        question_category_name: value,
                                                        question_category_key: value.replace(/\s+/g, '_'),
                                                        order_number: 1
                                                    }
                                                }
                                            });
                                        }
                                    }}
                                />
                            )}
                            disabled={!_.isEmpty(showPopUp?.data)}
                            sx={MuiCss}
                        />
                    </div>
                    <div className="col-md-3 col-12 my-1" style={{ width: "150px" }} >
                        <label>Display Name</label><span className="text-danger">*</span>
                        <input
                            type="text"
                            name="question_category_display_name"
                            value={formValue?.question_category_display_name}
                            onChange={handleOnChange}
                            className="w100 input-dd"
                        />
                    </div>
                    <div className="col-md-3 col-12 my-1">
                        <label>Order</label><span className="text-danger">*</span>
                        <input
                            value={formValue.order_number}
                            onChange={handleOnChange}
                            min={0}
                            type='number'
                            name="order_number"
                            className="w100 input-dd"
                        />
                    </div>
                    <div className="col-12 my-1">
                        <label>Question</label><span className="text-danger">*</span>
                        <textarea value={formValue?.question_title}
                            rows="3"
                            className="form-control"
                            onChange={handleOnChange}
                            name='question_title'
                        />
                    </div>
                    <div className="col-12 my-1">
                        <label>Sort title Question</label><span className="text-danger">*</span>
                        <textarea value={formValue?.question_short_title}
                            rows="1"
                            className="form-control"
                            onChange={handleOnChange}
                            name='question_short_title'
                        />
                    </div>
                    <div className='col-12 my-1'>
                        <div className='border rounded p-2'>
                            <label >Type<span className="text-danger">*</span></label>
                            <div className='d-flex justify-content-between my-2 py-2 px-4 rounded' style={{ background: "#cbcbcb" }}>
                                {
                                    options?.types?.map((val, index) => {
                                        return <div className={`c-pointer ${formValue?.type?.question_type_key === val?.question_type_key && "bold"}`} key={index} onClick={() => {
                                            if (!_.isEmpty(showPopUp?.data) && showPopUp?.data?.used > 0) {
                                                showInfo("Info", "Cannot change type: Question already used");
                                                return
                                            }
                                            handleOnChange({ target: { value: val, name: "type" } })
                                        }}>
                                            <FontAwesomeIcon icon={`fa-solid ${val?.icon}`} className='mx-2' />
                                            {val?.question_type_name}
                                        </div>
                                    })
                                }
                            </div>
                            {
                                formValue?.type?.question_type_key === "choice" && <div className='row'>
                                    <b> Choice Options </b><br />
                                    <div className='col-md-6 col-12'>
                                        <label className='my-2'>Type <span className="text-danger">*</span></label>
                                        <div>
                                            <label>
                                                <input type="radio" name="selection_mode" onChange={handleOnChange} checked={formValue?.selection_mode === "s"}
                                                    value="s" />
                                                Single Choice
                                            </label>
                                            <label>
                                                <input type="radio" name="selection_mode" onChange={handleOnChange} value="m" checked={formValue?.selection_mode === "m"} />
                                                Multiple Choice
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        formValue?.selection_mode === "m" && <div className='col-md-6 col-12'>
                                            <label className='my-2'>Max Section <span className="text-danger">*</span></label>
                                            <input
                                                value={formValue.max_selection}
                                                onChange={handleOnChange}
                                                min={2}
                                                type='number'
                                                name="max_selection"
                                                className="w100 input-dd"
                                            />
                                        </div>
                                    }

                                    {choiceOptions.map((option) => (
                                        <div key={option.id} className="d-flex  justify-content-between align-items-center mt-1 rounded">
                                            <input
                                                value={option.option_text}
                                                onChange={(e) => handleOptionChange(option.id, e.target.value)}
                                                placeholder={`Option ${option.id}`}
                                                className="w90 input-dd"
                                            />
                                            <FontAwesomeIcon
                                                icon="fa-solid fa-xmark"
                                                className='c-pointer'
                                                onClick={() => removeOption(option?.id)}
                                            />
                                        </div>
                                    ))}
                                    <div>
                                        <button className='btn-default my-2' onClick={addOption}>
                                            Add Choice
                                        </button></div>
                                    <div className="">
                                        <label className="fw-semibold">Preview:</label>
                                        <div className="w-full border rounded p-2">
                                            {formValue?.selection_mode === "s" ? (
                                                <div className="d-flex flex flex-column gap-2">
                                                    {choiceOptions.map((option) => (
                                                        <div key={option.id} className="d-flex gap-2 align-items-center c-pointer ">
                                                            <input
                                                                inputId={`preview-${option.id}`}
                                                                value={option.option_text}
                                                                type='radio'
                                                                name="pre-option"
                                                            />
                                                            <label htmlFor={`preview-${option.id}`} className="ml-2">{option.option_text}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="d-flex flex-column gap-2">
                                                    {choiceOptions.map((option) => (
                                                        <div key={option.id} className="d-flex gap-2 align-items-center c-pointer">
                                                            <input
                                                                inputId={`preview-${option.id}`}
                                                                value={option.option_text}
                                                                type='checkbox'
                                                                name="pre-option"
                                                            />
                                                            <label htmlFor={`preview-${option.id}`} className="ml-2">{option.option_text}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                formValue?.type?.question_type_key === "text" &&
                                <div className='row'>
                                    <b> Text Options</b><br />
                                    <div className='col-3'>
                                        <label>Min<span className="text-danger">*</span></label>
                                        <input
                                            value={formValue.min_length}
                                            onChange={handleOnChange}
                                            min={0}
                                            type='number'
                                            name="min_length"
                                            className="w100 input-dd"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <label>Max<span className="text-danger">*</span></label>
                                        <input
                                            value={formValue.max_length}
                                            onChange={handleOnChange}
                                            min={0}
                                            type='number'
                                            name="max_length"
                                            className="w100 input-dd"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <label>Regex Pattern<span className="text-danger">*</span></label>
                                        <input
                                            value={formValue.regex_pattern}
                                            onChange={handleOnChange}
                                            min={0}
                                            type='text'
                                            name="regex_pattern"
                                            className="w100 input-dd"
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <label className="fw-semibold">Preview:</label>
                                        <textarea
                                            rows="3"
                                            className="form-control"
                                            name=''
                                            placeholder="Respondent's answer..."
                                            disabled
                                        />
                                    </div>
                                </div>
                            }

                            {formValue?.type?.question_type_key === "rating" && (
                                <div className='row my-2'>
                                    <b> Rating Options</b><br />
                                    <div className='col-6'>
                                        <label>Level<span className="text-danger">*</span></label>
                                        <div className=' d-flex  gap-2 justify-content-between align-items-center'>
                                            <div className='w90 m-2 mt-3'>
                                                <Slider
                                                    value={formValue?.max_level}
                                                    name="max_level"
                                                    onChange={(e) => handleOnChange({ target: { value: e.value, name: "max_level" } })}
                                                    min={2}
                                                    max={10}
                                                />
                                            </div>
                                            <div>{formValue?.max_level}</div>
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <label>Symbol<span className="text-danger">*</span></label>
                                        <Dropdown
                                            name="rating_symbol"
                                            options={options?.symbol}
                                            value={formValue?.rating_symbol}
                                            onChange={handleOnChange}
                                            placeholder="Select a section"
                                            className="input-dd"
                                            optionLabel="rating_symbol_name"
                                        />
                                    </div>
                                    <div className='col-12 mt-3'>
                                        <label className="fw-semibold">Preview:</label>
                                        <div className='p-3 border rounded bg-light d-flex justify-content-center align-items-center flex-wrap gap-2'>
                                            <div className=" d-flex">
                                                {Array.from({ length: formValue?.max_level || 0 }, (_, index) => {
                                                    const symbols = options?.symbol || [];
                                                    const symbolKey = formValue?.rating_symbol?.rating_symbol_key || 'star';
                                                    const selectedSymbol = symbols.find(symbol =>
                                                        symbol?.rating_symbol_key === symbolKey
                                                    ) || { rating_symbol_key: 'star' };
                                                    return (
                                                        <span
                                                            key={index}
                                                            className="rating-icon cursor-pointer transition-all p-1 d-flex align-items-center"
                                                            style={{ fontSize: '16px' }}
                                                            title={`Level ${index + 1}`}
                                                        >
                                                            {getIcon(selectedSymbol?.rating_symbol_key, index)}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {
                                formValue?.type?.question_type_key === "date" && <div className='row'>
                                    <b className='my-2'>Date Options</b>
                                    <div className='d-flex gap-4'>
                                        <label>
                                            <input type="checkbox" name="is_allow_past" onChange={handleOnChange} checked={formValue?.is_allow_past}
                                                className='mx-2' />
                                            Allow past
                                        </label>
                                        <label>
                                            <input type="checkbox" name="is_allow_future" onChange={handleOnChange} checked={formValue?.is_allow_future} className='mx-2' />
                                            Allow future
                                        </label>
                                    </div>
                                    <div className='my-2'>
                                        <label className="fw-semibold">Preview:</label>
                                        <div className='inspectra-calendar'>
                                            <Calendar dateFormat='dd-mm-yy' style={{ height: "100%" }} placeholder="dd-mm-yy" disabled className='input-dd' />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-between bottom-0 end-0  my-2'>
                    <div className='d-flex align-items-center gap-1'>
                        <input type='checkbox' value={formValue?.create_same_question} onChange={(e) => setFormvalue((prev) => ({ ...prev, create_same_question: e.target?.checked }))} id="create_same_question" />
                        <label htmlFor="create_same_question">Create same type question</label>
                    </div>
                    <button onClick={handleSave}>Save</button>
                </div>
            </Dialog>
        </div >
    )
}

export default CreateQuestionBank